import { SELECT_TAB } from './constants'

export default (state = 0, action) => {
  switch (action.type) {
    case SELECT_TAB:
      return action.tabIndex
    default:
      return state
  }
}
